import {
  AtlasThemeProvider,
  atlasThemeOptions,
} from '@diligentcorp/atlas-theme-mui';
import {
  AppErrorHandlerProvider,
  AttachmentsProvider,
} from '@issuemanager/apps/client/contexts';
import { deepmerge } from '@mui/utils';
import { StrictMode, useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Pendo } from './components';
import ErrorBoundary from './components/ErrorBoundary';
import ApiProviderWrapper from './components/api/api-provider-wrapper';
import { GlobalNav } from './components/global-nav';
import Layout from './components/layout';
import PlatformHeader from './components/platform-header';
import { UniqueEnvironment } from './components/unique-environment/unique-environment';
import { SessionProvider, UserProvider } from './contexts';
import DateTimeLocalizationContainer from './contexts/date-time-localization-container';
import { EntitlementProvider } from './contexts/entitlement-context';
import { LoadingContextProvider } from './contexts/loading-context';
import { MonitoringProvider } from './contexts/monitoring-context';
import SnackbarProvider from './contexts/snackbar-provider';
import Routes from './pages/routes';
import * as tokens from './theme/tokens';
import './utils/supressWarnings';

export default function () {
  const themeOptions = useMemo(
    () =>
      deepmerge(atlasThemeOptions, {
        tokens: {
          ...tokens.dragAndDropTokens,
        },
      }),
    [],
  );

  return (
    <StrictMode>
      <UniqueEnvironment />
      <PlatformHeader />
      <ErrorBoundary>
        <AtlasThemeProvider themeOptions={themeOptions}>
          <SnackbarProvider>
            <BrowserRouter>
              <EntitlementProvider>
                <AppErrorHandlerProvider>
                  <ApiProviderWrapper>
                    <LoadingContextProvider>
                      <GlobalNav />
                      <SessionProvider>
                        <Pendo />
                        <UserProvider>
                          <MonitoringProvider>
                            <DateTimeLocalizationContainer>
                              <AttachmentsProvider>
                                <Layout>
                                  <Routes />
                                </Layout>
                              </AttachmentsProvider>
                            </DateTimeLocalizationContainer>
                          </MonitoringProvider>
                        </UserProvider>
                      </SessionProvider>
                    </LoadingContextProvider>
                  </ApiProviderWrapper>
                </AppErrorHandlerProvider>
              </EntitlementProvider>
            </BrowserRouter>
          </SnackbarProvider>
        </AtlasThemeProvider>
      </ErrorBoundary>
    </StrictMode>
  );
}
